module.exports = "/assets/data/dd8c8cf118c04dcca51c6b4f18fbd2ef-KA1.data.json";